(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mtb__header"] && !Shopify.designMode) return;
  try {
    
const suns = document.querySelectorAll(".mtb__nav-sun");
const moons = document.querySelectorAll(".mtb__nav-moon");
const toggleButtons = document.querySelectorAll(".mtb__nav-color-scheme-toggle");

function toggleTheme() {
    const html = document.documentElement;
    const isDark = html.classList.toggle('dark');
    currentColorScheme = isDark ? "dark" : "light";
    toggleIcon(isDark); 
    localStorage.setItem('theme', currentColorScheme);
}

function toggleIcon(isDark) {
    suns.forEach(sun => sun.style.display = isDark ? "none" : "block"); 
    moons.forEach(moon => moon.style.display = isDark ? "block" : "none");
}

// attach toggle to all buttons
toggleButtons.forEach(btn => btn.addEventListener('click', toggleTheme));

let currentColorScheme;

// Check localStorage first
let theme = localStorage.getItem("theme");
if (theme) {
    currentColorScheme = theme;
    if (theme === "dark") {
        document.documentElement.classList.add("dark");
        toggleIcon(true);
    } else {
        document.documentElement.classList.remove("dark");
        toggleIcon(false);
    }
} else {
    // fallback to system preference
    const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    if (prefersDark) {
        document.documentElement.classList.add("dark");
        currentColorScheme = "dark";
        toggleIcon(true);
    } else {
        document.documentElement.classList.remove("dark");
        currentColorScheme = "light";
        toggleIcon(false);
    }
}

// Listen for system preference changes (only if user hasn't set a theme)
window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
    if (!localStorage.getItem("theme")) {
        const newColorScheme = event.matches ? "dark" : "light";
        if (newColorScheme === "dark") {
            document.documentElement.classList.add("dark");
            currentColorScheme = "dark";
            toggleIcon(true);
        } else {
            document.documentElement.classList.remove("dark");
            currentColorScheme = "light";
            toggleIcon(false);
        }
    }
});

  } catch(e) { console.error(e); }
})();
})();
